import React from 'react';
import { useDeviceType } from '@cian/ui-kit';

import { formatDateToDDMMYYYY, formatTimeInMoscow, useFormatDate } from '../../utils';
import * as s from './DatePublished.css';

interface IDateTimePublished {
  /** Дата строкой вв ISO */
  children: string;
}

/**
 * Дата и время публикации
 */
export const DateTimePublished = ({ children }: IDateTimePublished) => {
  const formatDate = useFormatDate();
  const date = new Date(children);
  const deviceType = useDeviceType();
  const time = formatTimeInMoscow(new Date(children));
  const dateTimeFormatted =
    deviceType === 'phone'
      ? `${formatDateToDDMMYYYY(date)}, ${time}`
      : `${formatDate(date, { skipCurrentYear: true })}, ${time}`;

  return (
    <div className={s['wrapper']} title={`${formatDate(date)}, ${time}`}>
      {dateTimeFormatted}
    </div>
  );
};
